import React, { useEffect, useState } from "react";
// Import the custom configured axios instance
import axiosInstance from "../../../api_calls/axiosInstance";
import {
  Box,
  Grid,
  CircularProgress,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import MarkChatUnreadOutlinedIcon from "@mui/icons-material/MarkChatUnreadOutlined"; // ✅ new icon
import MarkChatReadOutlinedIcon from "@mui/icons-material/MarkChatReadOutlined";

import ChatCard from "./ChatCard";
import { useAuth } from "../../../context/AuthContext";
import { useChat } from "../../../context/ChatContext";
import { useUnread } from "../../../context/UnreadContext"; // ✅ NEW
import Configs from "../../../utils/Configs";

function ChatList() {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();
  const { openChat } = useChat();
  const { unreadCount } = useUnread(); // ✅ NEW

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    const userId = user?.user_id || "";

    axiosInstance
      .get(Configs.conversationsEp, { params: { user_id: userId } })
      .then((response) => {
        if (response.data.status === "success") {
          setConversations(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching conversations:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user]);

  const handleOpenChat = (conversation) => {
    const avatarPath = conversation.participant_profile_pic;
    const fullAvatarUrl = avatarPath.startsWith("http")
      ? avatarPath
      : `${Configs.baseUrl}${avatarPath}`;

    openChat({
      id: conversation.participant_user_id,
      name: conversation.participant_name,
      avatar: fullAvatarUrl,
      messages: [],
    });
  };

  // ✅ Heading text logic
  const getHeadingText = () => {
    if (unreadCount === 0) return "No new messages";
    if (unreadCount === 1) return "1 New message";
    return `${unreadCount} New messages`;
  };

  return (
    <Box>
      <Typography
        variant="h5"
        gutterBottom
        style={{ display: "flex", alignItems: "center", gap: 8 }}
      >
        {unreadCount > 0 ? (
          <MarkChatUnreadOutlinedIcon />
        ) : (
          <MarkChatReadOutlinedIcon />
        )}
        {getHeadingText()}
      </Typography>

      {loading ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <CircularProgress />
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ marginTop: 16 }}
          >
            Loading messages...
          </Typography>
        </Box>
      ) : conversations.length === 0 ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <Typography variant="body1" color="textSecondary">
            No chats found
          </Typography>
        </Box>
      ) : (
        <Box display="flex" justifyContent="flex-start" width="100%">
          <Grid
            container
            style={{
              width: "100%",
              maxWidth: isLargeScreen ? "33%" : "100%",
              padding: 0,
              margin: 0,
            }}
          >
            {conversations.map((conversation) => (
              <Grid
                item
                xs={12}
                key={conversation.conversation_id}
                style={{ margin: 0 }}
              >
                <ChatCard
                  conversation={conversation}
                  onSelect={handleOpenChat}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
}

export default ChatList;
